import { Phone, Send, MapPin, Clock, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";
import logo from "@/assets/logo.jpg";

const Footer = () => (
  <footer className="mt-6 border-t border-border bg-muted/20 md:mt-10">
    <div className="mx-auto max-w-7xl px-4 py-5 md:px-8 md:py-9 lg:px-12">
      <div className="grid grid-cols-2 gap-x-4 gap-y-4 md:grid-cols-4 md:gap-8">
        {/* Brand */}
        <div className="col-span-2 md:col-span-1">
          <div className="mb-2 flex items-center gap-2.5">
            <img src={logo} alt="Zebra Jaluzi" className="h-8 w-8 rounded-full object-cover" />
            <div>
              <h4 className="text-sm font-bold text-foreground tracking-tight">Zebra Jaluzi</h4>
              <p className="text-[10px] text-muted-foreground">С 1993 года</p>
            </div>
          </div>
          <p className="max-w-xs text-[11px] leading-relaxed text-muted-foreground">
            Премиальные жалюзи и москитные сетки на заказ в Ташкенте.
          </p>
        </div>

        {/* Contact */}
        <div>
          <h5 className="mb-2 text-[10px] font-bold uppercase text-foreground md:text-[11px]">Контакты</h5>
          <ul className="space-y-1.5 text-[10px] text-muted-foreground md:text-[11px]">
            <li>
              <a
                href="tel:+998781480001"
                onClick={() => trackEvent("click_call")}
                className="flex items-center gap-2 hover:text-foreground transition-colors"
              >
                <Phone className="h-3.5 w-3.5 shrink-0" />
                +998 78 148 00 01
              </a>
            </li>
            <li>
              <a
                href="https://t.me/zebrajaluzi"
                target="_blank"
                rel="noopener"
                onClick={() => trackEvent("click_telegram_cta")}
                className="flex items-center gap-2 hover:text-foreground transition-colors"
              >
                <Send className="h-3.5 w-3.5 shrink-0" />
                @zebrajaluzi
              </a>
            </li>
            <li>
              <a
                href="https://instagram.com/jaluzi.zebra"
                target="_blank"
                rel="noopener"
                className="flex items-center gap-2 hover:text-foreground transition-colors"
              >
                <Instagram className="h-3.5 w-3.5 shrink-0" />
                @jaluzi.zebra
              </a>
            </li>
          </ul>
        </div>

        {/* Address & Hours */}
        <div>
          <h5 className="mb-2 text-[10px] font-bold uppercase text-foreground md:text-[11px]">Адрес и режим работы</h5>
          <ul className="space-y-1.5 text-[10px] text-muted-foreground md:text-[11px]">
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0" />
              <span>г. Ташкент, Узбекистан<br />ул. А. Навоий, 16А</span>
            </li>
            <li className="flex items-start gap-2">
              <Clock className="mt-0.5 h-3.5 w-3.5 shrink-0" />
              <span>
                <span className="block text-foreground/80 font-medium">Офис / колл-центр</span>
                Пн–Вс: 09:00 – 18:00
                <span className="mt-1 block font-medium text-foreground/80">Установка</span>
                Ежедневно, без выходных
              </span>
            </li>
          </ul>
        </div>

        {/* Products */}
        <div className="col-span-2 md:col-span-1">
          <h5 className="mb-2 text-[10px] font-bold uppercase text-foreground md:text-[11px]">Продукция</h5>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-1 text-[10px] text-muted-foreground md:block md:space-y-1.5 md:text-[11px]">
            <li><Link to="/zhalyuzi-den-noch-tashkent" className="hover:text-foreground transition-colors">Жалюзи День-Ночь</Link></li>
            <li><Link to="/rulonnye-shtory-tashkent" className="hover:text-foreground transition-colors">Рулонные шторы</Link></li>
            <li><Link to="/plisse-tashkent" className="hover:text-foreground transition-colors">Жалюзи Плиссе</Link></li>
            <li><Link to="/moskitnye-setki-tashkent" className="hover:text-foreground transition-colors">Москитные сетки</Link></li>
            <li><Link to="/rolstavni-tashkent" className="hover:text-foreground transition-colors">Рольставни</Link></li>
            <li><Link to="/setka-plisse-tashkent" className="hover:text-foreground transition-colors">Сетки Плиссе</Link></li>
            <li><Link to="/shtory-dlya-vannoy-tashkent" className="hover:text-foreground transition-colors">Шторы для ванной</Link></li>
            <li><Link to="/zhalyuzi-tashkent-cena" className="hover:text-foreground transition-colors">Цены на жалюзи</Link></li>
            <li><Link to="/blog" className="hover:text-foreground transition-colors">Блог</Link></li>
            <li><Link to="/uz/jalyuzi-toshkent" className="hover:text-foreground transition-colors" hrefLang="uz">O‘zbekcha</Link></li>
            <li><Link to="/uz/aloqa" className="hover:text-foreground transition-colors" hrefLang="uz">O‘zbekcha aloqa</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-4 flex flex-col items-center justify-between gap-1 border-t border-border pt-3 text-[9px] text-muted-foreground md:mt-7 md:flex-row md:text-[10px]">
        <p>© {new Date().getFullYear()} Zebra Jaluzi. Все права защищены.</p>
        <p>Жалюзи и москитные сетки в Ташкенте</p>
      </div>
    </div>
  </footer>
);

export default Footer;
